// flow weak

import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Tabs,
  Tab,
  Modal,
  Form,
  Table
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { Redirect, Link } from "react-router-dom";
import { withRouter } from "react-router";

import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";

import "./dashboard.scss";
import {
  currentDealList
} from "../../../redux/actions/frontActions";
import {getSiteStatus}    from '../../../redux/actions/siteActions';
import noImg from "../../../img/no_img.jpg";
import noRecordFound from "../../../img/no-record-found.png";
import "react-responsive-tabs/styles.css";
import Timer from "./Timer";

import {
  FacebookShareButton,
  FacebookIcon,
  TwitterIcon,
  TwitterShareButton,
} from 'react-share';

import ReactHtmlParser from "react-html-parser";
import Reviews from "./Reviews.js";
import Question from "./Question.js";
import ReviewList from "./ReviewList.js";
import Cookies from "universal-cookie";
import auth from "../../../services/auth";
import moment from "moment";
import { appConfig } from "../../../config";
import UseDfpSlot from "./UseDfpSlot";
import ScriptSlot from "./ScriptSlot";

const cookies = new Cookies();


const history = createBrowserHistory();
let isLoading = false,
  limit = 7;
class Dashboard extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props, context) {
    super(props, context);
    this.state = {
      index: 0,
      direction: null,
      menuList: "",
      currentDeals: [],
      limit: 7,
      perPage: 7,
      total: "",
      topDealHighlights: "",
      button_color: '',
      mouseover_color: '',
      default_city: "",
      siteDomain: "",
      wdith: 0,
      height: 0,
      notifications: '',
      sending: false,
      notFoundPopup: false,
      hover: false,
      NoRecord:'',
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSelect = this.handleSelect.bind(this);

    this.pagination = this.pagination.bind(this);
  }

  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem("data-id").value });
  }
 
  hoverOff = (e) => { 
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem("data-id").value });    
  }

  getValidUrl = (url = "") => {
    let newUrl = window.decodeURIComponent(url);
    newUrl = newUrl.trim().replace(/\s/g, "");

    if(/^(:\/\/)/.test(newUrl)){
      return `http${newUrl}`;
    }
    if(!/^(f|ht)tps?:\/\//i.test(newUrl)){
        return `http://${newUrl}`;
      }

      return newUrl;
    }

  closenotFoundPopup = () => {
    this.setState({removePopup: false, total: ''});
  }
  pagination = () => {
    isLoading = true;
    limit = limit + this.state.perPage;
    const postData = {
      limit: limit,
      cityID : this.state.default_city,
      geolocation: "off",
    };

    this.props.currentDealList(postData);
  };

  handlePageChange = page => {
    isLoading = true;
    this.setState({
      currentPage: this.state.currentPage,
      sending: true
    });
    let default_city = this.state.default_city;
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(!this.state.default_city || this.state.default_city != siteData.default_city){
      if(siteData && siteData.default_city){
        this.setState({
          default_city: siteData.default_city,
          notifications: siteData.notifications,
          pending_offers: siteData.pending_offers,
        });
        default_city = siteData.default_city;
      }
    }
    
    const postData = {
      page: this.state.currentPage,
      limit: this.state.limit,
      geolocation: "off",
      giftvoucher: "yes",
    };

    if(default_city){
      postData.cityID = default_city;
    }

    this.props.currentDealList(postData);
  };

  onSearch = val => {
    this.handleSearch(val);
  };

  handleSearch(val) {
    const postData = {
      page: this.state.currentPage,
      search: val,
      geolocation: "off",
      giftvoucher: "yes",
    };

    if (val.length !== 0) {
      this.props.currentDealList(postData);
    } else {
      this.handlePageChange();
    }
  }
  componentWillMount(){
    isLoading = true;
  }
  componentDidMount() {
   if(this.props.themeData){
      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
      this.setState({NoRecord: this.props.themeData.NoRecord});
    }

    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      this.setState({siteDomain: siteData.siteDomain});
      if(siteData.default_city){
        this.setState({
          default_city: siteData.default_city,
          notifications: siteData.notifications,
          geoCityId: (siteData.country && siteData.country.default_geo_city) ? siteData.country.default_geo_city : '',
        });
      }
    }else{
      this.props.getSiteStatus();
    }
    this.handlePageChange(1);
    let userIDParams = this.props.match.params.user_ID
      ? this.props.match.params.user_ID
      : "";
    let Link = this.props.match.url;
    if (userIDParams !== "") {
      const token = auth.getToken();
      let d = new Date();
      d.setTime(d.getTime() + 480 * 60 * 1000);

      cookies.set("referredBy", userIDParams, { path: "/", expires: d });

      let url = appConfig.site.siteurl;
      cookies.set("referredLink", url + Link, { path: "/", expires: d });
      let referredLink = cookies.get("referredLink");

      this.context.router.history.push({ pathname: "/" });

      if (token !== null) {
        let d = new Date();
        d.setTime(d.getTime() + 480 * 60 * 1000);
      }
    }

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentWillReceiveProps(nextProps) {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      this.setState({notifications: siteData.notifications});
    }
    this.setState({sending: nextProps.sending});
    if(nextProps.match.params && nextProps.match.params.cityID && nextProps.match.params.cityID.length > 0  && nextProps.match.params.cityID != this.state.default_city){
      this.setState({
        default_city: nextProps.match.params.cityID
      });
      this.handlePageChange(1);
    }

    if((this.props.siteStatus != nextProps.siteStatus) && this.state.default_city == '' ){
      if(nextProps.siteStatus){
          this.handlePageChange(1);
      }
    }

    if(nextProps.themeData){
      if(nextProps.themeData.button){
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
      this.setState({NoRecord: nextProps.themeData.NoRecord});
    }

    if (nextProps.curDeal  && this.state.default_city !== '') {
        this.setState({ total: (nextProps.curDeal.total) ? nextProps.curDeal.total : 0, notFoundPopup: false });
        this.setState({ curDeal: nextProps.curDeal.data });
        isLoading = false;
    }else{
      this.setState({
        curDeal: '',
        topDeal: '',
        topDealHighlights: '',
        removePopup: true,
      })
    }

    if (this.props.error != nextProps.error) {
      if (nextProps.error) {
        isLoading = false;
      }
    }

  }

  shouldComponentUpdate(nextProps, nextState) {
      if ((this.state.curDeal === nextState.curDeal) && this.state.removePopup === false) {
          return false
      }
      return true
  }

  handleSelect(selectedIndex, e) {
    this.setState({
      index: selectedIndex,
      direction: e.direction
    });
  }
  
  render() {
    const { index, direction, notifications } = this.state;
    let currentDeals, totalDeal, position;

    if (!isEmpty(this.state.curDeal)) {
      totalDeal = this.state.curDeal.length;
      if(totalDeal > 2){
        position = 1;
      }else{
        position = totalDeal - 1;
      }

      currentDeals = this.state.curDeal.map((deal, index) => {
          return <React.Fragment key={Math.random() + index}>
          {(index == position) ?
            <React.Fragment>
            <Col lg={4} md={4} sm={4} xs={12} key={Math.random() + index}>
              <div className="gift-container shadow">
                <div className="deal-image">
                  <Image
                    src={
                      deal.dealImage ? deal.imageurl + deal.dealImage : noImg
                    }
                    alt={deal.img_alt_text}
                    title={deal.img_text}
                    description={deal.img_desc}
                    responsive
                  />
                </div>
                <h2 className="dealname"><b>{ReactHtmlParser(deal.mainDealText)}</b></h2>                
                <div className="deal-footer">
                  <a
                    className="btn btn-deal"               
                    style={{backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mouseover_color : this.state.button_color}}
                    data-id = {deal.dealID}
                    onMouseEnter={this.hoverOn} 
                    onMouseLeave={this.hoverOff}
                    onClick={() => (deal.offer_url) ? this.context.router.history.push(`/deals-detail/${deal.offer_url}`) : this.context.router.history.push(`/deals-detail/${deal.dealID}-${deal.legalName.toLowerCase().trim().split(/\s+/).join('-')}`)}
                  >
                    View
                  </a>
                </div>
              </div>
            </Col>
            {(this.state.notifications) &&
              this.state.notifications.map((data, index) => 
                (data.position == 'third_position') &&
                  <Col lg={4} md={4} sm={4} xs={12} key={Math.random() + index}>
                    <div className={data.content_type=='Ads Script' ? "gift-container ads" : "gift-container shadow"} key={Math.random() + index}>
                      <React.Fragment>
                      {(data.displayimage != '' || data.mobileappdisplay_image != '') ?
                        (this.state.width > 480 && data.remove_image == 1) ?
                          <a href={this.getValidUrl(data.display_image_link)} target="_blank"><Image src={data.displayimage} /></a>
                        :(this.state.width < 480 && data.remove_mobile_app_image == 1) ?
                        <a href={this.getValidUrl(data.display_image_link)} target="_blank"><Image src={data.mobileappdisplay_image} /></a>
                        :
                        <React.Fragment>
                          {data.content_type=='Ads Script' ?
                              data.scripttype=='other' ? 
                                <ScriptSlot datas={data} />
                              :
                                <UseDfpSlot datas={data} />
                            :
                              ((data.message != '') ? ReactHtmlParser(data.message) : '')
                          }
                        </React.Fragment>
                      :
                        <React.Fragment>
                          {data.content_type=='Ads Script' ?
                              data.scripttype=='other' ? 
                                <ScriptSlot datas={data} />
                              :
                                <UseDfpSlot datas={data} />
                            :
                              ((data.message != '') ? ReactHtmlParser(data.message) : '')
                          }
                        </React.Fragment>
                      }
                      </React.Fragment>
                    </div>
                  </Col>
              )
            }
            </React.Fragment>
          :
          <Col lg={4} md={4} sm={4} xs={12} key={Math.random() + index}>
            <div className="gift-container shadow">
              <div className="deal-image">
                <Image
                  src={
                    deal.dealImage ? deal.imageurl + deal.dealImage : noImg
                  }
                  alt={deal.img_alt_text}
                  title={deal.img_text}
                  description={deal.img_desc}
                  responsive
                />
              </div>
              <h2 className="dealname"><b>{ReactHtmlParser(deal.mainDealText)}</b></h2>
              <div className="deal-footer">
                <a
                  className="btn btn-deal"               
                  style={{backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mouseover_color : this.state.button_color}}
                  data-id = {deal.dealID}
                  onMouseEnter={this.hoverOn} 
                  onMouseLeave={this.hoverOff}
                  onClick={() => (deal.offer_url) ? this.context.router.history.push(`/deals-detail/${deal.offer_url}`) : this.context.router.history.push(`/deals-detail/${deal.dealID}-${deal.legalName.toLowerCase().trim().split(/\s+/).join('-')}`)}
                >
                  View
                </a>
              </div>
            </div>
          </Col>
          }
          </React.Fragment>
      });
    }
    return (
      <div>
        {(this.state.sending == true || isLoading == true) ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        {!isEmpty(this.state.curDeal) && isLoading != true ? (
        <React.Fragment>
        <div className="container">
          {/*<div className="heading">
            <h2 style={{background:'#111', color:'#fff'}}>Current Deals</h2>
          </div>*/}
          <Row>{currentDeals}</Row>
          {this.state.total > totalDeal ? (
            <Row>
              <Col
                lg={12}
                md={12}
                sm={12}
                xs={12}
                onClick={this.pagination}
                className="text-center"
              >
                <a 
                className="btn btn-deal" 
                style={{backgroundColor: (this.state.hover && this.state.hoverID == 'Load More') ? this.state.mouseover_color : this.state.button_color}}
                data-id = {'Load More'}
                onMouseEnter={this.hoverOn} 
                onMouseLeave={this.hoverOff}
                >
                Load More Deals
                </a>
              </Col>
            </Row>
          ) : null}
        </div>
        </React.Fragment>
        ):('')}
        {isEmpty(this.state.curDeal) && isLoading != true ? (
          <React.Fragment>
          <Row>
            <Col lg={12} md={1} sm={12} xs={12}>
              <Image src={(this.state.NoRecord ? this.state.NoRecord : noRecordFound)} responsive style={{margin: 'auto'}}/>
            }
            </Col>
          </Row>
          </React.Fragment>
        ):('')}
      </div>
    );
  }
}

// export default Dashboard;

Dashboard.propTypes = {
  currentDealList: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  curDeal: state.frontReducer.curDeal,
  error: state.frontReducer.error,
  sending: state.frontReducer.sending,
  siteStatus: state.siteReducer.siteStatus,
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    currentDealList, getSiteStatus
  })
)(Dashboard);



// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/GiftVoucher.js